import * as yup from "yup";

export interface PaymentFormContext {
  remaining: number;
}

export const paymentFormSchema = yup.object({
  payment_method_id: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value,
    )
    .typeError("required")
    .required("required"),
  amount: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value,
    )
    .typeError("required")
    .required("required")
    .moreThan(0, "amountMustBePositive")
    .test("max-remaining", "payAmountExceedsRemaining", function (value) {
      if (value == null) return true;
      const remaining =
        (this.options.context as PaymentFormContext | undefined)?.remaining ?? 0;
      return value <= remaining;
    }),
  note: yup.string().nullable(),
});

export type PaymentFormValues = yup.InferType<typeof paymentFormSchema>;

export const paymentFormDefaultValues: PaymentFormValues = {
  payment_method_id: undefined as unknown as number,
  amount: 0,
  note: "",
};
